export default __webpack_public_path__ + "images/close-button-white.svg";